import * as React from 'react';
import { cn } from '@/lib/cn';

/** The original app's panel surface (`.card` in index.css). */
export const Card = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('card', className)} {...props} />
));
Card.displayName = 'Card';
